// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"ac1fc253","637":"ec314feb","898":"ed1f1e2f"}[chunkId] + ".chunk.css";
};